import { action } from 'typesafe-actions';
import { PaymentEventDashboardActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const updatePaymentEventDashboardConfig = (data): any => action(types.UPDATE_PAYMENT_EVENT_DASHBOARD_CONFIG, data);

export default null;
